class AnimatedLogo extends HTMLElement {
  constructor() {
    super();
    this.animatedSection = this.querySelector(".animated-logo");
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    this.observerOptions = {
      root: null,
      rootMargin: "-50% 0px -50% 0px",
      threshold: 0,
    };

    if (window.innerWidth <= 989) {
      this.observerOptions.rootMargin = "-10% 0px 0px 0px";
    }

    this.observer = new IntersectionObserver(
      this.handleIntersection,
      this.observerOptions
    );

    this.observer.observe(this.animatedSection);
  }

  handleIntersection(entries, observer) {
    const headerLogo = document.querySelector("main-header #logo");

    if (headerLogo) {
      headerLogo.style.transition = "opacity 300ms linear";
    }

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        window.addEventListener("scroll", this.handleScroll);
        this.animatedSection.style.opacity = 1;

        if (headerLogo && headerLogo.style.opacity != 0) {
          headerLogo.style.opacity = 0;
        }
      } else {
        const headerLogo = document.querySelector("main-header #logo");

        if (headerLogo) {
          headerLogo.style.opacity = 1;
        }

        window.removeEventListener("scroll", this.handleScroll);
        this.animatedSection.style.opacity = 0;
      }
    });
  }

  handleScroll() {
    const scroll = window.scrollY || 1;
    const scrollDiff = scroll / (this.offsetTop + this.clientHeight);
    const scaleValue = Math.abs(scrollDiff - 1);

    this.animatedSection.style.transform = `scale(${Math.min(scaleValue, 1)})`;
  }
}

if (!customElements.get("animated-logo")) {
  customElements.define("animated-logo", AnimatedLogo);
}
